import { createSlice } from "@reduxjs/toolkit";
import GetLiveOrder from "../Actions/LiveOrder-Action";
const initialState = {
  data: [],
  loading: false,
  loadMore: false,
  isLoaded: false,
  startDate: new Date(),
  endDate: new Date(),
  active: {
    today: true,
    yesterday: false,
    week: false,
    month: false,
    from: false,
    to: false,
  },
  filter: "today",
  lastEvaluatedKey: "",
  status: "",
  timeIsloaded: false,
};
const LiveOrder = createSlice({
  name: "LiveOrder list",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setLoadMore(state, action) {
      state.loadMore = action.payload;
    },
    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
    setLiveOrderList(state, action) {
      state.data = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setActive(state, action) {
      state.active = action.payload;
    },
    setFilter(state, action) {
      state.filter = action.payload;
    },
    setLastEvaluatedKey(state, action) {
      state.lastEvaluatedKey = action.payload;
    },
    setTimeIsloaded(state, action) {
      state.timeIsloaded = action.payload;
    },
  },
  extraReducers: {
    [GetLiveOrder.pending]: (state, action) => {
      if (state.lastEvaluatedKey === "") {
        state.loading = true;
      } else {
        state.loadMore = true;
      }
    },
    [GetLiveOrder.fulfilled]: (state, action) => {
      console.log("response data", action.payload);
      let currentData = state.data;
      let data = action.payload;
      let temp = [];
      data.orders.map((order, i) => {
        temp.push(order);
        temp[i]["cart_total"] = order?.cartData?.Cart?.cart_total || "";
        temp[i]["created_at"] = order?.created_at
          ? new Date(order.created_at).toUTCString()
          : "";
        temp[i]["service_time"] = order?.service_time
          ? new Date(order?.service_time).toUTCString().replace(/ GMT/g, "")
          : "";
      });
      data.orders.sort((a, b) => {
        return b.readable_id - a.readable_id;
      });
      let newOrders = currentData.concat(data.orders);
      state.data = newOrders;
      state.lastEvaluatedKey = action?.payload?.lastEvaluatedKey
        ? action.payload.lastEvaluatedKey
        : "";
      state.loading = false;
      state.loadMore = false;
    },
    [GetLiveOrder.rejected]: (state, action) => {
      state.loading = false;
      state.loadMore = false;
      state.status = action.error.message;
    },
  },
});
export const LiveOrderAction = LiveOrder.actions;
export default LiveOrder.reducer;
